import type { JobStatus, JobTaskStatus } from '@maker-toolchest/shared';

type Status = JobStatus | JobTaskStatus;

interface StatusBadgeProps {
  status: Status;
  size?: 'sm' | 'md';
}

const statusConfig: Record<Status, { label: string; colors: string }> = {
  // Job statuses
  DRAFT: {
    label: 'Draft',
    colors: 'bg-gray-100 text-gray-700 dark:bg-gray-900/30 dark:text-gray-300',
  },
  READY: {
    label: 'Ready',
    colors: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  },
  PENDING: {
    label: 'Pending',
    colors: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  },
  QUEUED: {
    label: 'Queued',
    colors: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    colors: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  },
  COMPLETED: {
    label: 'Completed',
    colors: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  },
  FAILED: {
    label: 'Failed',
    colors: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  },
  CANCELLED: {
    label: 'Cancelled',
    colors: 'bg-gray-100 text-gray-700 dark:bg-gray-900/30 dark:text-gray-300',
  },
};

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status];

  if (!config) {
    return (
      <span
        className={`inline-flex items-center rounded-full font-medium ${
          size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-sm'
        } bg-gray-100 text-gray-700 dark:bg-gray-900/30 dark:text-gray-300`}
      >
        {status}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-sm'
      } ${config.colors}`}
    >
      {config.label}
    </span>
  );
}
